<cmp-side-card cardTitle="My wallet" faClass="far fa-wallet">
  @if (!!wallet()) {
    <div class="purple-greadient-bg border-radius p-[15px]">
      <div>Total wallet</div>
      <div class="mt-[10px] text-[40px]">{{ this.totalWalletValue() | currency }}</div>
    </div>

    <div class="ml-[5px] mt-[10px] text-text-secondary">Tokens in wallet</div>
    <div class="border-radius mt-[10px] max-h-[400px] overflow-auto bg-background-primary p-[10px]">
      @for (item of walletBalance(); track item.token.address; let isLast = $last) {
        <div class="items-center border-solid border-[#2e2e2e] py-4 pr-4" [ngClass]="{ 'border-b': !isLast }">
          <div class="flex items-center justify-between">
            <button class="flex text-left" (click)="openTokenPreview(item)">
              <cmp-pair-logo [url]="item.token.logoURI" [name]="item.token.symbol" sizeName="medium-large"></cmp-pair-logo>
              <div>
                <div class="ml-[10px] text-2xl">{{ item.token.symbol }}</div>
                <div class="ml-[10px] text-2xl text-success">
                  {{ item.walletValueUSD | currency }}
                </div>
              </div>
            </button>
            <div class="text-right">
              <div class="text-2xl">${{ item.mainLp.priceUSD | format }}</div>
              <div class="mt-[3px] text-text-secondary">{{ item.balance | format: { abbreviate: true } }} {{ item.token.symbol }}</div>
            </div>
          </div>
        </div>
      } @empty {
        <div class="py-[10px] text-text-secondary">No wallet tokens..</div>
      }
    </div>

    <div class="border-radius mt-[25px] bg-background-primary p-[15px]">
      <div class="text-text-secondary">Total staked</div>
      <div class="mt-[10px] text-[35px] text-tertiary">{{ this.totalStakeValue() | currency }}</div>
    </div>

    <div class="ml-[5px] mt-[10px] text-text-secondary">Staked tokens</div>
    <div class="border-radius mt-[5px] bg-background-primary p-[10px]">
      @for (item of stakeBalance(); track item.token.address; let isLast = $last) {
        <div class="items-center border-solid border-[#2e2e2e] py-4 pr-4" [ngClass]="{ 'border-b': !isLast }">
          <div class="flex items-center justify-between">
            <button class="flex text-left" (click)="openTokenPreview(item)">
              <cmp-pair-logo [url]="item.token.logoURI" [name]="item.token.symbol" sizeName="medium-large"></cmp-pair-logo>
              <div>
                <div class="ml-[10px] text-2xl">{{ item.token.symbol }}</div>
                <div class="ml-[10px] text-2xl text-success">
                  {{ item.stakeValueUSD | currency }}
                </div>
              </div>
            </button>
            <div class="text-right">
              <div class="text-2xl">
                {{ item.stakeBalance.totalStaked | format }}
                <span class="text-text-secondary">
                  {{ item.token.symbol }}
                </span>
              </div>
              <div class="mt-[3px] text-text-secondary">
                @if (!!+item.stakeBalance.accumulated) {
                  <span class="text-success">+ {{ item.stakeBalance.accumulated | format: { abbreviate: true } }}</span>
                } @else {
                  <span class="text-[12px]">No rewards</span>
                }
              </div>
            </div>
          </div>
        </div>
      } @empty {
        <div class="py-[10px] text-text-secondary">No staked tokens..</div>
      }
    </div>

    <div class="border-radius mt-[25px] bg-background-primary p-[15px]">
      <div class="flex items-center text-text-secondary">
        Total in LGE lp shares
        <div class="ml-auto text-[12px] text-white">BETA</div>
      </div>
      <div class="mt-[10px] text-[35px] text-tertiary">{{ this.totalLgeValue()?.total | currency }}</div>
    </div>

    <div class="ml-[5px] mt-[10px] text-text-secondary">My LGEs</div>
    <div class="border-radius mt-[5px] bg-background-primary p-[10px]">
      @for (item of walletLges(); track item.address; let isLast = $last) {
        <div class="items-center border-solid border-[#2e2e2e] py-4 pr-4" [ngClass]="{ 'border-b': !isLast }">
          <div class="flex items-center justify-between">
            <button class="flex cursor-pointer items-center" (click)="openLge(item)">
              <cmp-pair-logo [url]="item.token.logoURI" [name]="item.token.symbol" sizeName="medium-large"></cmp-pair-logo>
              <div>
                <div class="ml-[10px] text-left text-2xl">{{ item.token.symbol }}</div>
              </div>
            </button>

            @if (item.presaleEnded) {
              <div class="text-right">
                <div class="ml-[10px] text-2xl text-dirty-white">Round {{ item.vestingRound }} / {{ item.presaleSetup.vestingRounds }}</div>
              </div>
            } @else {
              <div class="text-right">
                <div class="ml-[10px] text-2xl text-dirty-white">
                  Raised {{ item.raised | format }} / {{ item.presaleSetup.hardCap | format }}
                  <span class="ml-[5px] text-dirty-white">{{ baseToken()?.symbol }}</span>
                </div>
              </div>
            }
          </div>

          @if (item.presaleEnded) {
            <div class="mt-[10px] flex items-center justify-between">
              <div class="flex items-center">
                <div class="w-[70px]">My share</div>

                <div class="ml-[5px] text-2xl text-success">
                  {{ item.shareUsdValues.total | currency }}
                </div>
              </div>

              <div class="mt-[3px] flex items-center">
                <div>
                  {{ item.shareEstimate.baseOut | format }}
                  <span class="ml-[5px] text-dirty-white">{{ baseToken()?.symbol }}</span>
                </div>
                <div class="ml-[10px]">
                  {{ item.shareEstimate.fegOut | format }}
                  <span class="ml-[5px] text-dirty-white">FEG</span>
                </div>
              </div>
            </div>

            <div class="mt-[5px] flex items-center justify-between">
              <div class="flex items-center">
                <div class="w-[70px]">Claimable</div>

                <div class="ml-[5px] text-2xl text-success">
                  {{ item.shareUsdValues.totalClaimable | currency }}
                </div>
              </div>

              <div class="mt-[3px] flex items-center">
                <div>
                  {{ item.claimable.basePairLp | format }}
                  <span class="ml-[5px] text-dirty-white">{{ baseToken()?.symbol }}</span>
                </div>
                <div class="ml-[10px]">
                  {{ item.claimable.fegPairLp | format }}
                  <span class="ml-[5px] text-dirty-white">FEG</span>
                </div>
              </div>
            </div>
          } @else {
            <div class="mt-[10px] flex items-center justify-between">
              <div class="flex items-center">
                <div class="w-[70px]">End time</div>
              </div>

              <div class="mt-[3px] flex items-center">
                {{ item.presaleEndTime.toShortDateTime() }}
              </div>
            </div>

            <div class="mt-[10px] flex items-center justify-between">
              <div class="flex items-center">
                <div>Amount entered</div>
              </div>

              <div class="mt-[3px] flex items-center">
                {{ item.amountIn | format }}
                <span class="ml-[5px] text-dirty-white">{{ baseToken()?.symbol }}</span>
              </div>
            </div>
          }
        </div>
      } @empty {
        <div class="py-[10px] text-text-secondary">No LGEs</div>
      }
    </div>
  } @else {
    <div class="info my-[10px] flex items-center justify-center py-[50px] text-text-secondary">
      <i class="fal fa-wallet mr-[10px] text-3xl text-blue"></i>
      Wallet not connected..
    </div>
    <cmp-button class="mt-[20px] w-full">Connect wallet</cmp-button>
  }
</cmp-side-card>
